import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import ErrorScreen from './screens/ErrorScreen';
import SignInScreen from './screens/SignInScreen';
import ProtectedRoute from './components/ProtectedRoute';
import LoadingScreen from './components/Loading/LoadingScreen';
import NavbarBeforeLogin from './components/Navbar/NavbarBeforeLogin';
import { UserProvider } from './context/UserContext';
import ServiceQRcode from './components/casher/ServiceQRcode';
import MedicationInvoiceQrcode from './components/casher/MedicationInvoiceQrcode';
import LabInvoiceForQrcode from './components/casher/LabInvoiceForQrcode';
import ImaginingQrcodeAttachment from './components/casher/ImaginingQrcodeAttachment';
import ProcedureQRcodeAttachment from './components/casher/ProcedureQRcodeAttachment';
import LabResultwithQRcode from './components/Labratory/LabResultwithQRcode';
import ImagingQRcodeResult from './components/Imaging/ImagingQRcodeResult';
import Footer from './components/Footer/Footer';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { ColorModeContext, tokens, useMode } from './theme';
import NotFound from './screens/NotFound';
import { SidebarProvider } from "./context/SidebarContext";
import MedicalQrcodeCerteficate from './components/certeficate/MedicalQrcodeCerteficate';
import HomeScreen from './screens/HomeScreen';
import ServicesOverview from './components/home/ServicesOverview';
import Announcements from './components/home/Announcements';
import Departments from './components/home/Departments';
import Doctors from './components/home/Doctors';
import WhyChooseUs from './components/home/WhyChooseUs';
import PublicFooter from './components/Footer/PublicFooter';
import FooterSelector from './components/Footer/FooterSelector';
// import AdminDashboard from './dashboard/AdminDashboard';
const AdminDashboard = React.lazy(() => import('./dashboard/AdminDashboard'));
// import AdminDashboard from './dashboard/AdminDashboard';
const CasherDashboard = lazy(() => import('./dashboard/CasherDashboard'));
const PharmacyDashboard = lazy(() => import('./dashboard/PharmacyDashboard'));
const SubStoremanDashboard = lazy(() => import('./dashboard/SubStoremanDashboard'));
const CardDashbaord = lazy(() => import('./dashboard/CardDashbaord'));
const DoctorDashboard = lazy(() => import('./dashboard/DoctorDashboard'));
const NurseDashboard = lazy(() => import('./dashboard/NurseDashboard'));
const LabratoryDashboard = lazy(() => import('./dashboard/LabratoryDashboard'));
const AnesthesiaDashboard = lazy(() => import('./dashboard/AnesthesiaDashboard'));
const ImagingDashboard = lazy(() => import('./dashboard/ImagingDashboard'));
const FinanceDashboard = lazy(() => import('./dashboard/FinanceDashboard'));
const TraigeDashboard = lazy(() => import('./dashboard/TraigeDashboard'));


const App = () => {
    const location = useLocation();
    const [theme, colorMode] = useMode();
	const colors = tokens(theme.palette.mode);
    // const showNavbarBeforeLogin = location.pathname === '/' || location.pathname === '/signup';

    const showNavbarBeforeLogin = location.pathname === '/' || 
                                  location.pathname === '/services' || 
                                  location.pathname === '/departments' ||
                                  location.pathname === '/doctors' ||
                                  location.pathname === '/announcements' ||
                                  location.pathname === '/doctors' ||
                                  location.pathname === '/login' ||
                                  location.pathname === '/contact-us' ||
                                  location.pathname === '/about';


    return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <UserProvider>
            {/* 🧩 SidebarProvider wraps everything that can use sidebar state */}
          <SidebarProvider>
            {showNavbarBeforeLogin && <NavbarBeforeLogin />}
            <Suspense fallback={<LoadingScreen />}>
            <Routes>
                {/* <Route path="/" element={<SignInScreen />} />
                <Route path="/login" element={<SignInScreen />} /> */}
                {/* asrat */}
            <Route path="/" element={<HomeScreen />} /> 
             <Route path="/login" element={<SignInScreen />} />
             <Route path="/services" element={< ServicesOverview />} />
              <Route path="/departments" element={<Departments />} />
              <Route path="/doctors" element={<Doctors />} />
              <Route path="/announcements" element={<Announcements />} />
              <Route path="/about" element={<WhyChooseUs />} />
              <Route path="/contact-us" element={<PublicFooter />} />
              {/* asrat */}
              
                <Route path="/service-payment-details" element={<ServiceQRcode />} />
                <Route path="/medication-invoice" element={<MedicationInvoiceQrcode />} />
                <Route path="/lab-invoice" element={<LabInvoiceForQrcode />} />
                <Route path="/imaging-invoice" element={<ImaginingQrcodeAttachment />} />
                <Route path="/procedure-invoice" element={<ProcedureQRcodeAttachment />} />
                <Route path="/lab-results" element={<LabResultwithQRcode />} />
                <Route path="/imaging-results" element={<ImagingQRcodeResult />} />
                <Route path="/medical-certeficate-data/:patientId" element={<MedicalQrcodeCerteficate />} />
                <Route path="*" element={<NotFound />} />
                <Route
                    path="/admin/*"
                    element={
                        <ProtectedRoute allowedRoles={['admin']}>
                            <AdminDashboard />
                        </ProtectedRoute>
                    }
                   />
                 <Route
                    path="/casher/*"
                    element={
                        <ProtectedRoute allowedRoles={['casher']}>
                            <CasherDashboard />
                        </ProtectedRoute>
                       }
                />
                <Route
                    path="/pharmacy/*"
                    element={
                        <ProtectedRoute allowedRoles={['pharmacy']}>
                            <PharmacyDashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/storeman/*"
                    element={
                        <ProtectedRoute allowedRoles={['storeman']}>
                            <SubStoremanDashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/card-room/*"
                    element={
                        <ProtectedRoute allowedRoles={['card-room']}>
                            <CardDashbaord />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/doctor/*"
                    element={
                        <ProtectedRoute allowedRoles={['doctor']}>
                            <DoctorDashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/labratory/*"
                    element={
                        <ProtectedRoute allowedRoles={['labratory']}>
                            <LabratoryDashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/nurse/*"
                    element={
                        <ProtectedRoute allowedRoles={['nurse']}>
                            <NurseDashboard />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/triage/*"
                    element={
                        <ProtectedRoute allowedRoles={['triage']}>
                            <TraigeDashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/anesthesia/*"
                    element={
                        <ProtectedRoute allowedRoles={['anesthesia']}>
                            <AnesthesiaDashboard />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/imaging/*"
                    element={
                        <ProtectedRoute allowedRoles={['imaging']}>
                            <ImagingDashboard />
                        </ProtectedRoute>
                    }
                />
                
                <Route
                path="/finance/*"
                element={
                    <ProtectedRoute allowedRoles={['finance']}>
                        <FinanceDashboard />
                    </ProtectedRoute>
                }
            />
            </Routes>
            </Suspense>
             <FooterSelector />
             </SidebarProvider>
            </UserProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
    );
};

const AppWrapper = () => (
    <BrowserRouter>
        <App />
    </BrowserRouter>
);
export default AppWrapper;
